(function () {
    'use strict';

    function itemOperations($log) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/itemOperations.html',
            scope: {
                target: '=',
                index: '='
            },
            link: function (scope, element, attrs) {
               if (scope.target == undefined) {
                   $log.error('could not find target for item operations ');
                   $log.debug(attrs);
               }
                Array.prototype.move = function (old_index, new_index) {
                    while (old_index < 0) {
                        old_index += this.length;
                    }
                    while (new_index < 0) {
                        new_index += this.length;
                    }
                    if (new_index >= this.length) {
                        var k = new_index - this.length;
                        while ((k--) + 1) {
                            this.push(undefined);
                        }
                    }
                    this.splice(new_index, 0, this.splice(old_index, 1)[0]);
                    return this; // for testing purposes
                };


                scope.moveItemUp = function () {
                    scope.target.move(scope.index, scope.index - 1);
                };

                scope.canMoveItemUp = function () {
                    return scope.index > 0;
                };

                scope.moveItemDown = function () {
                    scope.target.move(scope.index, scope.index + 1);
                };

                scope.canMoveItemDown = function () {
                    return scope.index < (scope.target.length - 1);
                };

                // Remove function
                scope.removeItem = function () {
                    scope.target.splice(scope.index, 1);
                };

            }
        };
    }

    itemOperations.$inject = ['$compile', '$http'];

    angular.module('ecap.common').directive('itemOperations', itemOperations);
})();
